<div class="list-paginator">
  <div class="lms-paginator">
    <span *ngIf="total">{{ first }}-{{ last }} de {{ total }}</span>
    <span
      [class.disabled]="disablePreviousPageArrow"
      class="glicon-left-arrow"
      (click)="!disablePreviousPageArrow && goToPage(page - 1)"
      title="{{ 'nouns.goBack' | translate }}"
    ></span>
    <span
      [class.disabled]="disableNextPageArrow"
      class="glicon-right-arrow"
      (click)="!disableNextPageArrow && goToPage(page + 1)"
      title="{{ 'nouns.goNext' | translate }}"
    ></span>
  </div>
</div>
